import React, { Component } from 'react'
import PlusIcon from '../icons/plusicon';
import FpgPlusIcon from '../icons/fpgplusicon';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DraggerIcon from '../icons/draggericon';
import CatEditIcon from '../icons/catediticon';
import FpgMinusIcon from '../icons/fpgminusicon';
import TextField from '../component/TextField'
import service from "../services";
import SimpleReactValidator from 'simple-react-validator';
import Loader from "../component/loader";
import commonImage from "../commonImage";
import PopUpCustomAll from "../component/fpg/create/popUpCustomAll";
import background from "../assets/images/background.jpg";
import plusIcon from "../assets/images/plusIcon.svg";
import DeletefileIcon from "../icons/DeletefileIcon";
//moment import
import moment from "moment";

//sweet alert
import swal from "sweetalert";

//Redux Connect
import { connect } from 'react-redux';

let sub;

const mapStateToProps = state => ({
    profileName: state.profileName,
})
class VenueType extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loaderFlag: false,
            addInterestmodal: false,
            isDraggable: false,
            editVenue: false,
            description: '',
            interest: "",
            updateId: '',
            venueList: [],
            lastUpdatedBy: "",
            lastUpdatedAt: "",
            updated: false
        }
        this.apiserve = new service();
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                interest: {  // name the rule
                    message: 'Interest Name is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                description: {  // name the rule
                    message: 'Interest Description is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                icon: {  // name the rule
                    message: 'Interest Icon is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
            }
        })
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    };

    componentDidMount = () => {
        var userRole = localStorage.getItem('currentUserRole')
        if (userRole=== "admin") {
            this.setState({ updated: true })
        }

        this.updatedAt()
        this.getVenueList();

        let self = this;
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "FestivalVillage|interest|getRefValue":

                    // var venueLists = response.data.location && response.data.location.venueType.map(function (el) {
                    //     let o = Object.assign({}, el);
                    //     return o;
                    // });
                    
                    var venueLists = response.data.docs
                    this.setState({
                        venueList: venueLists
                    })
                    break;
                case "FestivalVillage|interest|add":

                    if (!response.error) {
                        self.CloseModal();
                        self.getVenueList();
                    }
                    else {

                    }
                    break;
                case "FestivalVillage|interest|update":
                    if (!response.error) {
                        self.CloseModal();
                        self.getVenueList();
                    }
                    else {

                    }
                    break;
                case "FestivalVillage|interest|remove":
                    if (!response.error) {
                        self.CloseModal();
                        self.getVenueList();
                    }
                    else {

                    }
                    break;
                case "FestivalVillage|interest|changeOrder":
                    if (!response.error) {
                        self.getVenueList();
                    }
                    else {

                    }
                    break;
                case "location|getLastUpdated":
                    if (!response.error) {

                        this.setState({
                            lastUpdatedBy: response ?.data ?.updatedBy,
                            lastUpdatedAt: response ?.data ?.updatedAt,
                        })
                    }
                    break;
            }

        });
    };

    AddVenue = () => {
        this.validator.hideMessages("");
        this.setState({
            addInterestmodal: true,
            description: '',
            interest: ''
        })
    }

    CloseModal = () => {
        this.setState({
            addInterestmodal: false,
            editVenue: false,
            interest: '',
            description: '',
            satelliteLogo: '',
            updateId: ''
        })
        this.validator.hideMessages("");
    }

    editVenue = (data) => {
        
        this.setState({
            addInterestmodal: true,
            editVenue: true,
            interest: data.name,
            description: data.description,
            updateId: data._id,
            satelliteLogo: data.icon,
        })
    }
    updatedAt = () => {
        let data = {
            type: "3"
        }
        this.apiserve.sendevent("location|getLastUpdated", data);
    }
    getVenueList = () => {
        this.apiserve.sendevent("FestivalVillage|interest|getRefValue", {});
    }

    onInputChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;

        this.setState({
            [name]: value
        })
    }

    deleteVenue = (venue) => {
        swal({
            title: "Are you sure you want to delete this record?",
            text: "You want to delete this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                swal("Your record has been deleted!", {
                    icon: "success",
                });
                this.apiserve.sendevent("FestivalVillage|interest|remove", { interestId: venue._id });
            } else {
                swal("Your record is safe!");
            }
        });

    }

    onChangeFileSatelliteLogo(e) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {
                this.uploadAwardSponsorLogo.value = ''
                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 2048) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 2 MB'
                    })
                    return false;
                }
                if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                    setTimeout(() => {
                        this.imageUploadSatelliteLogo(file,event.target.result);
                    }, 0)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            });
        }
    }
    imageUploadSatelliteLogo = (file,img) => {
        this.setState({ imagePreloader1: true })

        var fileSet = commonImage(file,false,'',img)
        fileSet.then((value) => {
                this.setState({
                    satelliteLogo: value,
                    imagePreloader1: false
                });
            });
    };
    deleteImagePopup = () => {
        if (this.state.isLogo) {
            this.setState({
                satelliteLogo: '',
                deleteImagePopup: false
            })
        } else {
            this.setState({
                satelliteScreenThumbnail: '',
                deleteImagePopup: false,
            })
        }

    }
    deleteImage(e) {
        this.setState({
            isLogo: e,
            deleteImagePopup: true,
        })
    }
    closeAdminUser = () => {
        this.setState({
            deleteImagePopup: false
        });
    };
    submitFn = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({ loaderFlag: true })
            const { interest, description, updateId } = this.state;
            let data;

            if (updateId) {
                data = {
                    name: interest,
                    description: description,
                    interestId: updateId,
                    icon: this.state.satelliteLogo ?  this.state.satelliteLogo : '',
                }
            }
            else {
                data = {
                    name: interest,
                    description: description,
                    icon: this.state.satelliteLogo
                }
            }
            this.setState({ loaderFlag: false, addInterestmodal: false })
            this.apiserve.sendevent(updateId ? "FestivalVillage|interest|update" : "FestivalVillage|interest|add", data);
            this.getVenueList()
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    onDragEnd = (result) => {
        const { destination, source } = result;
        const oldIndex = source.index;
        const newIndex = destination.index;
        const arr = [...this.state.venueList];

        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
        const updateArr = [];
        arr.forEach(({ _id }, i) => {
            updateArr.push({
                interestId: _id,
                sortIndex: i + 1,
            });
        });

        const data = { order: updateArr };
        this.apiserve.sendevent("FestivalVillage|interest|changeOrder", data);


        this.setState({ isDraggable: true });
        this.setState({ venueList: arr });
    }

    render() {
        var updateAt = new Date(this.state.lastUpdatedAt)
        var hour = moment(updateAt).format('h')
        var minutes = moment(updateAt).format('mm')
        var state = moment(updateAt).format('A')
        return (
            <div className="right_side_wrapper ">
                <ul className="fpg_admin_tab disp_flex">
                    <li className="active">
                        <p className="uppercase text_left">
                            <div>Festival Village</div>
                            <span onClick={this.AddVenue}><PlusIcon /></span>
                        </p>
                    </li>
                </ul>
                <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                    <p></p>
                    <p className="update_date">
                        Last Update: {hour}:{minutes} {state} -  {moment(this.state.lastUpdatedAt).format('MM/DD/YY')}
                    </p>
                </div>
                <div className="cat_outer_content">
                    <div className="category_add_edit">
                        <div className="category_header relative">
                            <p>Interests</p>
                            <span className="add_icon d_flex" onClick={this.AddVenue}>
                                <FpgPlusIcon
                                    width="16"
                                    height="16"
                                    color="#ffffff"
                                    stroke="#4F4F4F"
                                />
                            </span>
                        </div>
                        <div className="list_wrap striped_droppable_table">
                            <DragDropContext onDragEnd={this.onDragEnd}>
                                <Droppable droppableId="droppable">
                                    {(provided, snapshot) => (
                                        <ul {...provided.droppableProps} ref={provided.innerRef}>
                                            {this.state.venueList.map((item, index) => (
                                                <Draggable
                                                    key={item._id}
                                                    draggableId={item._id}
                                                    index={index}
                                                >
                                                    {(provided, snapshot) => (
                                                        <li
                                                            className="pointer d_flex d_flex_align_center"
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <span className="cat_drag d_flex">
                                                                <DraggerIcon />
                                                            </span>
                                                            <p className="cat_name">{item.name}</p>
                                                            <div className="action d_flex d_flex_align_center">
                                                                {this.state.updated ?
                                                                    <>
                                                                    <span
                                                                        className="cat_edit pointer"
                                                                        onClick={() => this.editVenue(item)}
                                                                    >
                                                                        <CatEditIcon />
                                                                    </span>
                                                                    <span
                                                                        className="remove_cat pointer"
                                                                        onClick={() => this.deleteVenue(item)}
                                                                    >
                                                                        <FpgMinusIcon
                                                                            width="16"
                                                                            height="16"
                                                                            color="#4F4F4F"
                                                                        />
                                                                    </span>
                                                                    </>
                                                                    : ""}
                                                            </div>
                                                        </li>
                                                    )}
                                                </Draggable>
                                            ))}
                                        </ul>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </div>
                    </div>
                </div>

                {/* Loader */}
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                        ""
                    )}
                
                {/* popup */}
                <div className={`user_popup ${this.state.addInterestmodal ? "active" : ""}`} >
                    <span className="popup_overlay" onClick={this.CloseModal}></span>
                    <div className="cat_modal_inner">
                        <p className="cat_title text_center">
                            {this.state.editVenue ? 'Edit Interest' : 'Interest'}
                        </p>
                        <form>
                            <div className="field_row horizontal_field d_flex">
                                <TextField
                                    type="text"
                                    label="Interest Name"
                                    name="interest"
                                    value={this.state.interest}
                                    onChange={this.onInputChange}
                                    fpgerror={this.validator.message('interest', this.state.interest, 'interest|required')}
                                />

                            </div>
                            <div className="field_row horizontal_field d_flex">
                                <label>Interest Description</label>
                                <div className="textarea_wrap">
                                    <textarea
                                        type="text"
                                        rows="12"
                                        name="description"
                                        value={this.state.description}
                                        onChange={this.onInputChange}
                                    ></textarea>
                                    <span style={{ color: "red" }}>
                                        {this.validator.message('description', this.state.description, 'description|required')}
                                    </span>
                                </div>
                            </div>
                            <div class="field_row horizontal_field d_flex"><label>Interest Icon</label>
                                <div className="field_input relative">
                                    <div className="media_image mb_0 absolute_loader relative">
                                        {this.state.imagePreloader1 ?
                                            <Loader />
                                            :
                                            <img src={this.state.satelliteLogo ? this.apiserve.imageUrl + this.state?.satelliteLogo : '/images/image-placeholder2.png'} alt="image" />
                                        }
                                        <div className={`input_file ${this.state.satelliteLogo ? 'active' : ''}`}>
                                            <input id="myInput"
                                                type="file"
                                                ref={(ref) => this.uploadAwardSponsorLogo = ref}
                                                style={{ display: 'none' }}
                                                onChange={this.onChangeFileSatelliteLogo.bind(this)}
                                                accept=".png, .jpg, .jpeg"
                                                name="icon"
                                            />
                                            <span onClick={() => { this.uploadAwardSponsorLogo.click() }}><img src={plusIcon} /></span>
                                        </div>
                                        {this.state.satelliteLogo &&
                                            <span className="remove_file pointer" onClick={() => this.deleteImage(true)}><DeletefileIcon /></span>
                                        }
                                    </div>
                                    <span style={{ color: "red" }}>
                                        {this.validator.message('icon', this.state.satelliteLogo, 'icon|required')}
                                    </span>
                                </div>
                                {/* <div className='image_pre_loader'>
                                            <input id="myInput"
                                                type="file"
                                                ref={(ref) => this.upload1 = ref}
                                                style={{ display: 'none' }}
                                                onChange={this.onChangeFileSatelliteLogo.bind(this)}
                                                accept=".png, .jpg, .jpeg"
                                            />
                                            {this.state.imagePreloader1 ?
                                                <Loader />
                                                :
                                                <img src={this.state.satelliteLogo
                                                    ? this.apiserve.imageUrl + this.state.satelliteLogo
                                                    : background
                                                } />
                                            }
                                            <a className={this.state.satelliteLogo ? "add_file_img active" : 'add_file_img'} onClick={() => { this.upload1.click() }} ><img src={plusIcon} /></a>
                                            {this.state.satelliteLogo ?
                                                <span className="remove_file pointer"
                                                    onClick={()=>this.deleteImage(true)}
                                                ><DeletefileIcon /></span> :''}
                                        </div> */}
                            </div>
                            <div className="cat_btns text_center">
                                <button type="button" onClick={this.CloseModal}>
                                    CANCEL
                    </button>
                                <button className="active" onClick={(e) => this.submitFn(e)}>
                                    {this.state.updateId ? 'UPDATE' : 'SAVE'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                {this.state.deleteImagePopup ? (
                    <PopUpCustomAll
                        HeaderName="Delete Image?"
                        insideDetails="Are You Sure ?"
                        insideData="You want to delete this image"
                        popupState={this.closeAdminUser}
                        yesPopUp={this.deleteImagePopup}
                    />
                ) : (
                        ""
                    )}
            </div>



        )
    }
}

export default connect(mapStateToProps)(VenueType);
